export enum TradePointFormatEnum {
    Autocafe,
    CoffeeIsland,
    Cafe,
    FoodTruck,
    Stop,
    FoodCourt,
}
